"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.KeyOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var KeyOutlineSVG = function KeyOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.83 2a1 1 0 0 0-.688.274l-.19.18a1 1 0 0 0-.312.726v2.35h-2.4a1 1 0 0 0-1 1v2.36h-2.37a1 1 0 0 0-.707.293l-1.184 1.184a10 10 0 1 0 6.608 6.31l7.951-7.97A1 1 0 0 0 29.83 8V3a1 1 0 0 0-1-1h-5zm.81 4.53V4h3.19v3.586l-8.118 8.138a1 1 0 0 0-.212 1.098 8 8 0 1 1-4.596-4.374 1 1 0 0 0 1.053-.23l1.327-1.328h2.956a1 1 0 0 0 1-1V7.53h2.4a1 1 0 0 0 1-1zM9.358 20.37a1.67 1.67 0 0 1 .962-.27v.05c.442.005.865.18 1.18.49a1.67 1.67 0 0 1-1.82 2.725A1.63 1.63 0 0 1 9.14 23a1.67 1.67 0 0 1 .218-2.63z",
    stroke: "none"
  }));
};
exports.KeyOutlineSVG = KeyOutlineSVG;
KeyOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(KeyOutlineSVG);
exports.default = _default;